export default __webpack_public_path__ + "static/media/64t.4eb22948.jpg";